import { useRecoilValue } from 'recoil';
import { opcInfoAtom } from '../recoil/atoms/opcInfoAtom';
import type {
    AddRemoveCoverageIdentifier,
    CommonOPCIdentifier,
    EditAttributeIdentifier,
    TermChangeIdentifier
} from '../recoil/types/opcTypes';

interface OPCInfomation {
    editAttribute: EditAttributeIdentifier;
    addRemoveCoverage: AddRemoveCoverageIdentifier;
    termChange: TermChangeIdentifier;
}

const useOpcInfomation = (): OPCInfomation => {
    const opcInfo = useRecoilValue(opcInfoAtom);
    const {
        productName,
        coverableId,
        coverageId,
        attribute,
        attributeValue,
        termId,
        adjustAction
    } = opcInfo;

    const commonInfo: CommonOPCIdentifier = {
        productName,
        coverableId
    };

    const addRemoveCoverage: AddRemoveCoverageIdentifier = {
        ...commonInfo,
        coverageId: coverageId ?? ''
    };

    const editAttribute: EditAttributeIdentifier = {
        ...commonInfo,
        attribute: attribute ?? '',
        attributeValue: attributeValue ?? ''
    };

    const termChange: TermChangeIdentifier = {
        ...addRemoveCoverage,
        termId: termId ?? '',
        adjustAction
    };
    return {
        editAttribute,
        addRemoveCoverage,
        termChange
    };
};

export { useOpcInfomation };
